// extracted by mini-css-extract-plugin
export default {"wrapper":"ScreenSaver_wrapper__cWnBk","iconWrapper":"ScreenSaver_iconWrapper__7nz1v"};